<!--
@负责人: zhijie.huang
@创建时间: 2018-11-08
@版本: v2.0.0
@描述: 图表多图列表
@使用方法:
<template>
  <chart-list :chart-data-list="chartDataList"></chart-list>
</template>
<script>
  import chartList from '@/components/chart/chart-dashboard-list.vue'
  drawChart (dataList) {
    const list = []
    dataList.map((data, index) => {
      const chartData = {
        title: 'BSS_SAASLoginSuccess',
        chartId: `some-${index}`,
        chartData: {
          rows: data,
          columns: ['eventTime', 'value'],
          formatMap: {
            eventTime: 'TIME'
          }
        }
      }
      list.push(chartData)
    })
    this.chartDataList = list
  }
</script>
@参数说明:
// 图表数据数组
chartDataList = [chartItem + style]
chartItem 参考 chart-config.vue
style: {
  width,
  height,
  x
  y
}
// 是否支持右侧按钮
clickable
// 是否支持缩放
resizeable
// 是否支持拖动
dragable
// 是否黑色主题
// darkTheme
@事件说明
// 点击了右上角的按钮，回传 index,data
chart-conf-click
-->
<style>
.flip-list-move {
  transition: transform 0.4s;
  margin-bottom: 16px;
}
.chart-dashboard-list__item {
  position: relative;
  display: inline-block;
  margin: 0 16px 16px 0;
  vertical-align: top;
  background: #F0F0F0;
}
.chart-dashboard-list__item-icon {
  position: absolute;
  right: 5px;
  bottom: 5px;
  cursor: se-resize;
}

</style>
<template>
  <div>
    <transition-group v-if="dragable" name="flip-list" tag="ul">
      <li class="chart-dashboard-list__item"
        :ref="'chart-'+index"
        v-for="(item, index) in chartDataList"
        v-dragging="{ item: item, list: chartDataList, group: 'item', key: item.chartId }"
        :key="item.chartId"
        :style="{cursor: 'move'}">
        <chart-config :ref="item.chartId"
          v-if="item.chartId"
          :icon="icon"
          :title="item.title"
          :type="item.type"
          :dom-style="{width: item.style.width + 'px', height: item.style.height + 'px'}"
          :chart-style="item.chartStyle || chartStyle"
          :chart-index="index" 
          :chart-id="item.chartId" 
          :chart-data="item.chartData" 
          :click-fun="onItemClick"
          :clickable="clickable"
          :show-color-icon="false">
        </chart-config>
        <i class="icon icon-resize-bottom-right chart-dashboard-list__item-icon"
          v-show="resizeable"
          @mousedown="resizeChart($event, index)">
        </i>
      </li>
    </transition-group>
    <ul v-else class="chart-dashboard-list">
      <li class="chart-dashboard-list__item"
        :ref="'chart-'+index"
        v-for="(item, index) in chartDataList"
        :key="item.chartId">
        <chart-config :ref="item.chartId"
          v-if="item.chartId"
          :icon="icon"
          :title="item.title"
          :type="item.type"
          :dom-style="{width: item.style.width + 'px', height: item.style.height + 'px'}"
          :chart-style="item.chartStyle || chartStyle"
          :chart-index="index" 
          :chart-id="item.chartId" 
          :chart-data="item.chartData" 
          :click-fun="onItemClick"
          :clickable="clickable"
          :show-color-icon="false">
        </chart-config>
        <i class="icon icon-resize-bottom-right chart-dashboard-list__item-icon"
          v-show="resizeable"
          @mousedown="resizeChart($event, index)">
        </i>
      </li>
    </ul>
  </div>
</template>
<script type="text/javascript">
import chartConfig from './chart-config'
export default {
  components: {
    chartConfig
  },
  data () {
    const that = this
    return {
      chartStyle: {
        grid: {
          left: '4%',
          bottom: '6%',
          top: '10%',
          right: '6%',
          containLabel: true
        }
      },
      icon: {
        label: that.$t('common.delete'),
        classname: 'icon-guanbi'
      },
      sizeTemp: {}
    }
  },
  props: {
    'chartDataList': {
      type: Array
    },
    'resizeable': {
      type: Boolean,
      default: true
    },
    'clickable': {
      type: Boolean,
      default: true
    },
    'dragable': {
      type: Boolean,
      default: true
    }
  },
  watch: {
  },
  methods: {
    onItemClick (index) {
      this.$emit('chart-dashboard-click', {
        index: index,
        data: this.chartDataList[index]
      })
    },
    resizeChart (e, index) { // TODO 待优化 hzj
      const that = this
      const dataItem = that.chartDataList[index]
      const domItem = that.$refs['chart-' + index][0]
      let x = e.clientX
      let y = e.clientY
      let chartX, chartY

      chartX = Number(dataItem.style.width)
      chartY = Number(dataItem.style.height)

      document.onmousemove = function (event) {
        let moveX = Number(event.clientX - x)
        let moveY = Number(event.clientY - y)

        const resX = Number(chartX + moveX)
        const resY = Number(chartY + moveY)

        let obj = {
          width: resX + 'px',
          height: resY + 'px',
          screenWidth: window.screen.width
        }

        domItem.style.width = obj.width
        domItem.style.height = obj.height

        that.sizeTemp.width = resX
        that.sizeTemp.height = resY

        return false
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null

        that.$set(that.chartDataList[index], `style`, {
          width: that.sizeTemp.width,
          height: that.sizeTemp.height
        })
        const chartId = that.chartDataList[index].chartId
        setTimeout(that.$refs[chartId][0].resize)
      }
      return false
    }
  },
  mounted () {
  }
}
</script>